/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const SupplierDeliveryDTOStatusEnum = {
    Ordered: 'ORDERED',
    Shipped: 'SHIPPED',
    OutForDelivery: 'OUT_FOR_DELIVERY',
    Delayed: 'DELAYED',
    Delivered: 'DELIVERED',
    Cancelled: 'CANCELLED',
    Lost: 'LOST',
    ReturnedToSender: 'RETURNED_TO_SENDER',
    Refunded: 'REFUNDED',
    Unknown: 'UNKNOWN'
};
/**
 * @export
 */
export const SupplierDeliveryDTOAlertEnum = {
    None: 'NONE',
    DueToday: 'DUE_TODAY',
    Delayed: 'DELAYED',
    AwaitingWarehouseReceipt: 'AWAITING_WAREHOUSE_RECEIPT',
    NotArriving: 'NOT_ARRIVING',
    BuyerOrderCancelled: 'BUYER_ORDER_CANCELLED',
    StatusUnknown: 'STATUS_UNKNOWN',
    NotChecked: 'NOT_CHECKED'
};
/**
 * Check if a given object implements the SupplierDeliveryDTO interface.
 */
export function instanceOfSupplierDeliveryDTO(value) {
    return true;
}
export function SupplierDeliveryDTOFromJSON(json) {
    return SupplierDeliveryDTOFromJSONTyped(json, false);
}
export function SupplierDeliveryDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'status': json['status'] == null ? undefined : json['status'],
        'statusText': json['statusText'] == null ? undefined : json['statusText'],
        'deliveredAt': json['deliveredAt'] == null ? undefined : (new Date(json['deliveredAt'])),
        'checkedAt': json['checkedAt'] == null ? undefined : (new Date(json['checkedAt'])),
        'trackingId': json['trackingId'] == null ? undefined : json['trackingId'],
        'promisedDeliveryDate': json['promisedDeliveryDate'] == null ? undefined : (new Date(json['promisedDeliveryDate'])),
        'expectedDeliveryDate': json['expectedDeliveryDate'] == null ? undefined : (new Date(json['expectedDeliveryDate'])),
        'alert': json['alert'] == null ? undefined : json['alert'],
        'receiptReminderCaseNumber': json['receiptReminderCaseNumber'] == null ? undefined : json['receiptReminderCaseNumber'],
        'receiptReminderAt': json['receiptReminderAt'] == null ? undefined : (new Date(json['receiptReminderAt'])),
    };
}
export function SupplierDeliveryDTOToJSON(json) {
    return SupplierDeliveryDTOToJSONTyped(json, false);
}
export function SupplierDeliveryDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'status': value['status'],
        'statusText': value['statusText'],
        'deliveredAt': value['deliveredAt'] == null ? undefined : ((value['deliveredAt']).toISOString()),
        'checkedAt': value['checkedAt'] == null ? undefined : ((value['checkedAt']).toISOString()),
        'trackingId': value['trackingId'],
        'promisedDeliveryDate': value['promisedDeliveryDate'] == null ? undefined : ((value['promisedDeliveryDate']).toISOString().substring(0, 10)),
        'expectedDeliveryDate': value['expectedDeliveryDate'] == null ? undefined : ((value['expectedDeliveryDate']).toISOString().substring(0, 10)),
        'alert': value['alert'],
        'receiptReminderCaseNumber': value['receiptReminderCaseNumber'],
        'receiptReminderAt': value['receiptReminderAt'] == null ? undefined : ((value['receiptReminderAt']).toISOString()),
    };
}
